import { render, staticRenderFns } from "./PcRepartitionWidget.vue?vue&type=template&id=221159ba"
import script from "./PcRepartitionWidget.vue?vue&type=script&lang=js"
export * from "./PcRepartitionWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports